import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

export type ChangelogFlagBag = {
  enableChangelog?: boolean | null | undefined;
  enableOrgDesign?: boolean | null | undefined;
};

export type ChangelogAttributeFlagBag = ChangelogFlagBag & {
  /** Accepted so callers can pass the workspace bag. Not part of the gate. */
  enableDemoODOptions?: boolean | null | undefined;
  enableOrgChartAttributeOverlays?: boolean | null | undefined;
  /** Accepted so callers can pass the workspace bag. Not part of the gate. */
  enableOrgChartEditableAttributes?: boolean | null | undefined;
};

/**
 * Org design release on ⇒ changelog flag on. Not written back: org design off
 * leaves the stored flag (default off unless turned on manually). Beta does
 * not affect changelog.
 */
export const withChangelogAutoEnable = <T extends ChangelogFlagBag>(
  flags: T
): T => {
  if (!flags?.enableOrgDesign || flags.enableChangelog) {
    return flags;
  }
  return { ...flags, enableChangelog: true };
};

/**
 * Changelog attribute rows follow people-attribute overlays.
 * Org design release, beta, and editable attributes are not part of this
 * gate. Editable off still shows entries that arrive from integration.
 */
export const isChangelogAttributesEnabled = (
  flags: ChangelogAttributeFlagBag | null | undefined
): boolean => Boolean(flags?.enableOrgChartAttributeOverlays);

export const useChangelogAttributesEnabled = (): boolean =>
  isChangelogAttributesEnabled(useWorkspaceFeatureFlags());
